import { render, staticRenderFns } from "./ActeProposition.vue?vue&type=template&id=2ec66466&"
import script from "./ActeProposition.vue?vue&type=script&lang=js&"
export * from "./ActeProposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports